<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    :width="width"
    :custom-class="customClass"
    :top="top"
    :destroy-on-close="destroyOnClosen"
    center
    @close="handleClose(false)"
    v-if="isShow"
  >
    <div class="dialog-content">
      <slot name='content'></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <slot name='btns'>
        <el-button type="info" plain  @click="handleClose(false)">取消</el-button>
        <el-button type="primary" @click="handleClose(true)">确定</el-button>
      </slot>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowDialog: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '40%'
    },
    top: String,
    enterEvent: {
      type: Function,
      default: () => {}
    },
    destroyOnClosen: {
      type: Boolean,
      default: false
    },
    noBorderTop: Boolean
  },
  data () {
    return {
      isShow: false,
      customClass: 'border-top'
    }
  },
  watch: {
    isShowDialog: {
      handler: function (newData) {
        this.isShow = newData
        sessionStorage.setItem('isShowDialog', newData)
        if (newData) {
          this.handleDialogOpen()
        } else {
          this.handleDialogClose()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.handleDialogOpen()
  },
  updated () {
    this.customClass = this.noBorderTop ? '' : 'border-top'
  },
  methods: {
    handleClose (b) {
      this.$emit('handleClick', b)
    },
    handleDialogOpen () {
      document.addEventListener('keyup', this.handleKeyUp)
    },
    handleDialogClose () {
      document.removeEventListener('keyup', this.handleKeyUp)
    },
    handleKeyUp (event) {
      if (event.key === 'Enter') {
        this.confirmAction()
      }
    },
    confirmAction () {
      this.enterEvent()
    }
  },
  beforeDestroy () {
    this.handleDialogClose()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  font-family: MiSans;
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #EDEEF2;
    font-size: 16px;
    font-weight: 400;
    color: #464C5E;
  }
  .el-dialog__title {
    font-size:16px;
    line-height: 50px;
  }
  .el-dialog__body {
    padding: 20px 30px;
    .el-cascader--medium {
      width: 100%;
    }
  }
  .el-dialog__footer {
    padding: 9px 0;
    .el-button {
      padding: 10px 20px;
      font-size: 14px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
    .el-button--info.is-plain {
      color: #49515C;
      background: #E1E3E6;
    }
  }
}
::v-deep{
  .border-top{
    .el-dialog__footer {
      padding-top: 10px;
      border-top: 1px solid #EDEEF2;
    }
  }
}
</style>